import React from "react";

function Love()
{
    return(
        <div className="love">
            <footer>Made with ❤️ by <span className="myName">Ishani</span></footer>
        </div>
    );
}

export default Love;